module.exports = __webpack_public_path__ + "components/country-flag/static/gw-442e700de324c517fda86121705acd21.svg";